import {withNavigationWatcher} from '../../../contexts/navigation';
import Customers from '../../../pages/customers/index';

const customersRoutes = [
    {
        path: '/customers',
        component:Customers
    }
]

export default customersRoutes.map(route => {
    return {
        ...route,
        component: withNavigationWatcher(route.component)
    };
});
